<script>
    export let timeScale;
    export let time_range;
    export let height;

    const [time_begin, time_end] = $time_range;

    function range(min, max) {
        return [...Array(max - min).keys()].map((i) => i + min);
    }

    function dayStart(day, _) {
        return time_begin + day * (24 * 3600) * 1000;
    }

    function dayWidth(day, range) {
        return (
            timeScale(dayStart(day + 1, range)) -
            timeScale(dayStart(day, range))
        );
    }
</script>

<g>
    {#each range(0, 14) as day}
        {#if dayStart(day) < $time_range[1] && dayStart(day) + 24 * 3600 * 1000 > $time_range[0]}
            <rect
                x={timeScale(dayStart(day), $time_range)}
                width={dayWidth(day, $time_range)}
                y="0"
                {height}
                class="dayrect"
                class:odd={day % 2 == 0}
            />
        {/if}
    {/each}
</g>

<style>
    .dayrect {
        fill: white;
        opacity: 0.2;
    }
    .dayrect.odd {
        fill: grey;
    }
</style>
